import { useMemo } from 'react';
import { IPromoModalProps } from '@cian/frontend-newbuilding-promo-modal-widget';
import { useApplicationContext } from '../../utils/applicationContext';
import { getPromoModalConfig } from '../../utils/config';

export const usePromoDetailsConfig = (): IPromoModalProps['config'] => {
  const { config } = useApplicationContext();
  const promoModalConfigRs = getPromoModalConfig(config);

  return useMemo(() => {
    return {
      listingBaseUrlDesktop: promoModalConfigRs?.listingBaseUrlDesktop,
      listingBaseUrlMobile: promoModalConfigRs?.listingBaseUrlMobile,
      fullCreditPriceModalText: promoModalConfigRs?.fullCreditPriceModalText,
    };
  }, [promoModalConfigRs]);
};
